import React from 'react';
import styles from './footer.module.scss'

function Footer(){
    return (
        <div className={styles.footer}>Gwaith {new Date().getFullYear()} | made by <a href='https://www.helenadw.com'>helenadw</a></div>

    );
} 
export default Footer;